<template>
  <div
    class="loading-spinner-wrapper d-flex align-center justify-center"
    :class="{ 'full-height': fullHeight, ...wrapperClass }"
    :style="wrapperStyle"
  >
    <v-progress-circular
      :color="color"
      :indeterminate="indeterminate"
      :size="size"
      :width="width"
      :model-value="modelValue"
    />
    <div v-if="message" class="mt-2 text-center">
      <span :class="messageClass">{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    // Spinner appearance
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: [Number, String],
      default: 48
    },
    width: {
      type: [Number, String],
      default: 2
    },
    indeterminate: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Number,
      default: 0
    },
    // Optional loading message
    message: {
      type: String,
      default: ''
    },
    messageClass: {
      type: String,
      default: 'text-body-2'
    },
    // Wrapper styling
    fullHeight: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: [String, Object, Array],
      default: ''
    },
    wrapperStyle: {
      type: [String, Object],
      default: ''
    }
  }
};
</script>

<style scoped>
.loading-spinner-wrapper {
  flex-direction: column;
}

.loading-spinner-wrapper.full-height {
  min-height: 200px;
}
</style>
